import { gql } from "@apollo/client";

const GET_USER_GUIDE = gql`
  query GetUserGuide($agentId: ID!) {
    getUserGuide(agentId: $agentId) {
      id
      agentId
      welcomeTourCompleted
      teamSetupCompleted
      postFbConnectionCompleted
      dashboardTourCompleted
      reportsTourCompleted
      chatScreenTourCompleted
      channelConnected
      settingsTourCompleted
      facebookGuideCompleted
      instagramGuideCompleted
      whatsappGuideCompleted
    }
  }
`;
export default GET_USER_GUIDE;
